import { render } from "./onlineReservationCustomer.vue?vue&type=template&id=1fe7ddc4&scoped=true"
import script from "./onlineReservationCustomer.vue?vue&type=script&lang=js"
export * from "./onlineReservationCustomer.vue?vue&type=script&lang=js"

import "./onlineReservationCustomer.vue?vue&type=style&index=0&id=1fe7ddc4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe7ddc4"]])

export default __exports__